import {
    WidgetStrategy,
    WidgetStrategyWithRestApiByRequestUid,
} from 'widgets/WidgetRegistry';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import React from 'react';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import DarkVenueHeatmap from 'widgets/darkVenueHeatmap/DarkVenueHeatmap.tsx';
import { DarkVenueHeatmapApiResponse } from 'widgets/darkVenueHeatmap/api/DarkVenueHeatmapApiResponse.ts';
import { darkVenueHeatmapStreamConfig } from 'widgets/darkVenueHeatmap/stream-config.ts';
import { DarkVenueHeatmapRequest } from 'widgets/darkVenueHeatmap/store/data/DarkVenueHeatmapRequest.ts';
import DarkVenueHeatmapHelpText from 'widgets/darkVenueHeatmap/DarkVenueHeatmapHelpText.tsx';
import DarkVenueHeatmapPreview from './DarkVenueHeatmapPreview.png';

export const darkVenueHeatmapDescription: DropdownTooltipText = {
    body: <DarkVenueHeatmapHelpText />,
    previews: [
        { src: DarkVenueHeatmapPreview, altText: 'dark-venue-heatmap-preview' },
    ],
};

export const darkVenueHeatmapStrategy: WidgetStrategy &
    WidgetStrategyWithRestApiByRequestUid<
        DarkVenueHeatmapRequest,
        DarkVenueHeatmapApiResponse
    > = {
    title: 'US Dark Venue Heatmap',
    supportedHosts: ['layout'],
    reactComponentType: DarkVenueHeatmap,
    description: darkVenueHeatmapDescription,
    categories: [WidgetCategory.SINGLE_STOCK],
    requiredAuthorities: ['indigo.darkVenueHeatmapStrategy'],
    portfolioSelectionRequirements: PortfolioSelectionRequirements.SingleSymbol,
    managedStreamConfig: darkVenueHeatmapStreamConfig,
};
